"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_link_1 = require("@hotelplan/components.common.link");
const components_common_logo_1 = require("@hotelplan/components.common.logo");
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const graphql_types_1 = require("@hotelplan/graphql.types");
const libs_language_1 = require("@hotelplan/libs.language");
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
const HeaderLogoLink = (0, styled_components_1.default)(components_common_link_1.Link)(({ theme }) => theme.header.logo);
const HeaderLogo = ({ logo, logoRouterProps }) => {
    const [, { language }] = (0, next_i18next_1.useTranslation)();
    const routerProps = (0, react_1.useMemo)(() => {
        if (logoRouterProps) {
            return logoRouterProps;
        }
        else {
            const route = (0, libs_router_config_1.getRouteByPageTypeLocale)(graphql_types_1.PageType.Home, language);
            return (0, libs_router_link_utils_1.getTargetPageData)({
                targetPageType: graphql_types_1.PageType.Home,
                uri: route
                    ? route.builder({})
                    : language !== libs_language_1.languageDefault
                        ? `/${language}`
                        : '/',
            });
        }
    }, [language, logoRouterProps]);
    return logo ? (react_1.default.createElement(components_common_router_link_1.RouterLink, Object.assign({}, routerProps, { passHref: true }),
        react_1.default.createElement(HeaderLogoLink, null,
            react_1.default.createElement(components_common_logo_1.Logo, Object.assign({}, logo, { testId: "header-logo" }))))) : null;
};
exports.default = HeaderLogo;
//# sourceMappingURL=HeaderLogo.js.map